import process from 'node:process'

export default class Config {
  private static env: Record<string, any> = {}
  private static construct = this.init()

  static apiUrl = this.env.VITE_API_URL as string
  static baseUrl = this.env.VITE_BASE_URL as string
  static chartColors = [
    '#33A277',
    '#7BD5B2',
    '#B7E370',
    '#DFEC4E',
    '#FFE587',
    '#F9AF6C',
    '#3A4772',
    '#7552D9',
    '#8F73FF',
    '#53E2E2'
  ]
  static communicationLanguages = ['de', 'en', 'fr']
  static defaultCommunicationLanguage = 'de'
  static languages = ['de', 'en', 'fr']
  static ssr = import.meta.env.SSR

  private static init() {
    if (import.meta.env.SSR && process.env.NODE_ENV === 'production') {
      Config.env = Object.keys(process.env)
        .filter((key) => key.startsWith('VITE_'))
        .reduce((env, key) => {
          // @ts-ignore
          env[key] = process.env[key]
          return env
        }, {})
    } else {
      Config.env = import.meta.env
    }
    return undefined
  }

  private static afterConstruct = (function () {
    // @ts-ignore
    if (!import.meta.env.SSR && window['Config']) {
      // @ts-ignore
      const config = window['Config'] as Record<string, any>
      config['ssr'] = false
      Object.keys(config).forEach((key) => {
        // @ts-ignore
        Config[key] = config[key]
      })
    }
    return undefined
  })()
}
